function updateCartCount(count) {
  const btn = document.querySelector('.header__cart-btn');
  if (btn) btn.textContent = `🛒 Bag (${count})`;
}

async function addToCart(variantId, quantity = 1) {
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count);
    showNotification('Added to bag!');
  } catch (e) { console.error(e); }
}

function showNotification(message) {
  const el = document.createElement('div');
  el.style.cssText = 'position:fixed;bottom:28px;right:28px;background:#B8845A;color:white;padding:14px 24px;border-radius:2px;font-family:"Plus Jakarta Sans",sans-serif;font-size:13px;font-weight:600;letter-spacing:0.06em;z-index:9999;box-shadow:0 8px 32px rgba(28,21,19,0.18);transition:all 0.3s;';
  el.textContent = message;
  document.body.appendChild(el);
  setTimeout(() => { el.style.opacity = '0'; setTimeout(() => el.remove(), 300); }, 2800);
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('.quantity-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') val = Math.min(val + 1, 99);
      if (this.dataset.action === 'decrease') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  document.querySelectorAll('.product-add-form').forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const variantId = this.querySelector('[name="id"]').value;
      const qty = parseInt(this.querySelector('.quantity-input')?.value || 1);
      const btn = this.querySelector('[type="submit"]');
      btn.textContent = 'Adding...';
      btn.disabled = true;
      await addToCart(variantId, qty);
      btn.textContent = 'Add to Bag';
      btn.disabled = false;
    });
  });

  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});

  const mainImg = document.getElementById('mainProductImage');
  document.querySelectorAll('.product-page__thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      if (mainImg) mainImg.src = this.dataset.full;
      document.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  const lightbox = document.getElementById('productLightbox');
  const lightboxImg = document.getElementById('lightboxImage');
  if (mainImg && lightbox && lightboxImg) {
    mainImg.addEventListener('click', function() {
      lightboxImg.src = this.src.replace(/width=\d+/, 'width=1600');
      lightbox.classList.add('active');
    });
  }
  if (lightbox) {
    lightbox.addEventListener('click', function() {
      this.classList.remove('active');
    });
  }
});
